module.exports = "/images/refund_policy.svg?9b8170e8ec171b627174ec5ca143c630";